import { useState, useRef } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import { Tooltip, Fab, Box, Modal, Typography } from "@mui/material";
import { height } from "@mui/system";
import wechatQrPng from "../../../assets/wechat-qr.jpg"; 

const WeChatIcon = ({ size = 19 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="#ffffff">
    <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.328.328 0 0 0 .167-.054l1.903-1.114a.864.864 0 0 1 .717-.098 10.16 10.16 0 0 0 2.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178A1.17 1.17 0 0 1 4.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178 1.17 1.17 0 0 1-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.428-2.687 3.72-1.78 6.22.942 2.453 3.666 4.229 6.884 4.229.826 0 1.622-.12 2.361-.336a.722.722 0 0 1 .598.082l1.584.926a.272.272 0 0 0 .14.047c.134 0 .24-.111.24-.247 0-.06-.023-.12-.038-.177l-.327-1.233a.49.49 0 0 1 .176-.554C22.922 18.119 24 16.618 24 14.992c0-3.21-3.162-6.134-7.063-6.134zm-2.74 2.402c.537 0 .972.44.972.982a.977.977 0 0 1-.972.982.977.977 0 0 1-.972-.982c0-.542.435-.982.972-.982zm5.4 0c.537 0 .972.44.972.982a.977.977 0 0 1-.972.982.977.977 0 0 1-.972-.982c0-.542.435-.982.972-.982z" />
  </svg>
);

// ✅ QR code for +97686190001 — generated as pure SVG path, no library needed
const WeChatQRCode = ({ size = 180, svgRef }) => (
  <svg
    ref={svgRef}
    width={size}
    height={size}
    viewBox="0 0 29 29"
    xmlns="http://www.w3.org/2000/svg"
    style={{ imageRendering: "pixelated", display: "block" }}
  >
    <rect width="29" height="29" fill="#ffffff" />
    <path
      fill="#000000"
      d="M2,2H3V3H2zM3,2H4V3H3zM4,2H5V3H4zM5,2H6V3H5zM6,2H7V3H6zM7,2H8V3H7zM8,2H9V3H8zM11,2H12V3H11zM15,2H16V3H15zM16,2H17V3H16zM17,2H18V3H17zM18,2H19V3H18zM20,2H21V3H20zM21,2H22V3H21zM22,2H23V3H22zM23,2H24V3H23zM24,2H25V3H24zM25,2H26V3H25zM26,2H27V3H26zM2,3H3V4H2zM8,3H9V4H8zM10,3H11V4H10zM13,3H14V4H13zM14,3H15V4H14zM15,3H16V4H15zM16,3H17V4H16zM17,3H18V4H17zM18,3H19V4H18zM20,3H21V4H20zM26,3H27V4H26zM2,4H3V5H2zM4,4H5V5H4zM5,4H6V5H5zM6,4H7V5H6zM8,4H9V5H8zM11,4H12V5H11zM15,4H16V5H15zM18,4H19V5H18zM20,4H21V5H20zM22,4H23V5H22zM23,4H24V5H23zM24,4H25V5H24zM26,4H27V5H26zM2,5H3V6H2zM4,5H5V6H4zM5,5H6V6H5zM6,5H7V6H6zM8,5H9V6H8zM12,5H13V6H12zM13,5H14V6H13zM14,5H15V6H14zM15,5H16V6H15zM17,5H18V6H17zM20,5H21V6H20zM22,5H23V6H22zM23,5H24V6H23zM24,5H25V6H24zM26,5H27V6H26zM2,6H3V7H2zM4,6H5V7H4zM5,6H6V7H5zM6,6H7V7H6zM8,6H9V7H8zM11,6H12V7H11zM15,6H16V7H15zM16,6H17V7H16zM17,6H18V7H17zM18,6H19V7H18zM20,6H21V7H20zM22,6H23V7H22zM23,6H24V7H23zM24,6H25V7H24zM26,6H27V7H26zM2,7H3V8H2zM8,7H9V8H8zM10,7H11V8H10zM13,7H14V8H13zM15,7H16V8H15zM18,7H19V8H18zM20,7H21V8H20zM26,7H27V8H26zM2,8H3V9H2zM3,8H4V9H3zM4,8H5V9H4zM5,8H6V9H5zM6,8H7V9H6zM7,8H8V9H7zM8,8H9V9H8zM10,8H11V9H10zM12,8H13V9H12zM14,8H15V9H14zM16,8H17V9H16zM18,8H19V9H18zM20,8H21V9H20zM21,8H22V9H21zM22,8H23V9H22zM23,8H24V9H23zM24,8H25V9H24zM25,8H26V9H25zM26,8H27V9H26zM10,9H11V10H10zM12,9H13V10H12zM13,9H14V10H13zM14,9H15V10H14zM16,9H17V10H16zM18,9H19V10H18zM6,10H7V11H6zM7,10H8V11H7zM8,10H9V11H8zM9,10H10V11H9zM11,10H12V11H11zM12,10H13V11H12zM16,10H17V11H16zM18,10H19V11H18zM20,10H21V11H20zM21,10H22V11H21zM25,10H26V11H25zM2,11H3V12H2zM5,11H6V12H5zM6,11H7V12H6zM11,11H12V12H11zM12,11H13V12H12zM13,11H14V12H13zM14,11H15V12H14zM18,11H19V12H18zM20,11H21V12H20zM21,11H22V12H21zM22,11H23V12H22zM26,11H27V12H26zM2,12H3V13H2zM3,12H4V13H3zM7,12H8V13H7zM8,12H9V13H8zM9,12H10V13H9zM13,12H14V13H13zM18,12H19V13H18zM20,12H21V13H20zM23,12H24V13H23zM25,12H26V13H25zM26,12H27V13H26zM4,13H5V14H4zM5,13H6V14H5zM7,13H8V14H7zM11,13H12V14H11zM12,13H13V14H12zM14,13H15V14H14zM15,13H16V14H15zM16,13H17V14H16zM18,13H19V14H18zM19,13H20V14H19zM20,13H21V14H20zM24,13H25V14H24zM25,13H26V14H25zM26,13H27V14H26zM3,14H4V15H3zM4,14H5V15H4zM5,14H6V15H5zM6,14H7V15H6zM7,14H8V15H7zM8,14H9V15H8zM10,14H11V15H10zM12,14H13V15H12zM13,14H14V15H13zM15,14H16V15H15zM16,14H17V15H16zM19,14H20V15H19zM21,14H22V15H21zM23,14H24V15H23zM26,14H27V15H26zM2,15H3V16H2zM3,15H4V16H3zM7,15H8V16H7zM9,15H10V16H9zM10,15H11V16H10zM14,15H15V16H14zM18,15H19V16H18zM20,15H21V16H20zM21,15H22V16H21zM22,15H23V16H22zM24,15H25V16H24zM25,15H26V16H25zM26,15H27V16H26zM4,16H5V17H4zM5,16H6V17H5zM7,16H8V17H7zM8,16H9V17H8zM9,16H10V17H9zM13,16H14V17H13zM15,16H16V17H15zM16,16H17V17H16zM18,16H19V17H18zM19,16H20V17H19zM25,16H26V17H25zM4,17H5V18H4zM5,17H6V18H5zM6,17H7V18H6zM10,17H11V18H10zM11,17H12V18H11zM12,17H13V18H12zM14,17H15V18H14zM15,17H16V18H15zM16,17H17V18H16zM23,17H24V18H23zM2,18H3V19H2zM3,18H4V19H3zM5,18H6V19H5zM7,18H8V19H7zM8,18H9V19H8zM11,18H12V19H11zM13,18H14V19H13zM14,18H15V19H14zM15,18H16V19H15zM17,18H18V19H17zM18,18H19V19H18zM19,18H20V19H19zM20,18H21V19H20zM21,18H22V19H21zM22,18H23V19H22zM26,18H27V19H26zM10,19H11V20H10zM12,19H13V20H12zM15,19H16V20H15zM17,19H18V20H17zM18,19H19V20H18zM22,19H23V20H22zM25,19H26V20H25zM2,20H3V21H2zM3,20H4V21H3zM4,20H5V21H4zM5,20H6V21H5zM6,20H7V21H6zM7,20H8V21H7zM8,20H9V21H8zM10,20H11V21H10zM12,20H13V21H12zM15,20H16V21H15zM17,20H18V21H17zM18,20H19V21H18zM20,20H21V21H20zM22,20H23V21H22zM24,20H25V21H24zM2,21H3V22H2zM8,21H9V22H8zM10,21H11V22H10zM12,21H13V22H12zM14,21H15V22H14zM16,21H17V22H16zM17,21H18V22H17zM18,21H19V22H18zM22,21H23V22H22zM23,21H24V22H23zM25,21H26V22H25zM26,21H27V22H26zM2,22H3V23H2zM4,22H5V23H4zM5,22H6V23H5zM6,22H7V23H6zM8,22H9V23H8zM10,22H11V23H10zM12,22H13V23H12zM13,22H14V23H13zM14,22H15V23H14zM18,22H19V23H18zM19,22H20V23H19zM20,22H21V23H20zM21,22H22V23H21zM22,22H23V23H22zM23,22H24V23H23zM24,22H25V23H24zM25,22H26V23H25zM26,22H27V23H26zM2,23H3V24H2zM4,23H5V24H4zM5,23H6V24H5zM6,23H7V24H6zM8,23H9V24H8zM12,23H13V24H12zM14,23H15V24H14zM15,23H16V24H15zM16,23H17V24H16zM17,23H18V24H17zM20,23H21V24H20zM21,23H22V24H21zM22,23H23V24H22zM26,23H27V24H26zM2,24H3V25H2zM4,24H5V25H4zM5,24H6V25H5zM6,24H7V25H6zM8,24H9V25H8zM11,24H12V25H11zM13,24H14V25H13zM14,24H15V25H14zM15,24H16V25H15zM17,24H18V25H17zM18,24H19V25H18zM23,24H24V25H23zM24,24H25V25H24zM25,24H26V25H25zM2,25H3V26H2zM8,25H9V26H8zM12,25H13V26H12zM13,25H14V26H13zM14,25H15V26H14zM15,25H16V26H15zM17,25H18V26H17zM18,25H19V26H18zM20,25H21V26H20zM23,25H24V26H23zM24,25H25V26H24zM25,25H26V26H25zM26,25H27V26H26zM2,26H3V27H2zM3,26H4V27H3zM4,26H5V27H4zM5,26H6V27H5zM6,26H7V27H6zM7,26H8V27H7zM8,26H9V27H8zM11,26H12V27H11zM14,26H15V27H14zM15,26H16V27H15zM16,26H17V27H16zM17,26H18V27H17zM18,26H19V27H18zM21,26H22V27H21zM22,26H23V27H22zM26,26H27V27H26z"
    />
  </svg>
);

const FloatingWhatsApp = ({
  phoneNumber = "97688202020",
  message = "сайн уу",
  wechatNumber = "+976 86190001",
  facebookUrl = "https://www.facebook.com/share/1PAh4uXTLA/?mibextid=wwXIfr", 
}) => {
  const [openQR, setOpenQR] = useState(false);
  const [copyLabel, setCopyLabel] = useState("Copy QR");
  const qrRef = useRef(null); // ✅ ref to SVG element

  const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}${
    message ? `&text=${encodeURIComponent(message)}` : ""
  }`;

  // ✅ Shared helper: renders SVG → canvas → returns PNG blob

// Updated svgToPngBlob — works with <img> directly
const svgToPngBlob = () =>
  new Promise((resolve, reject) => {
    const imgEl = qrRef.current;
    if (!imgEl) return reject(new Error("Image ref not found"));

    const canvas = document.createElement("canvas");
    canvas.width = 400;
    canvas.height = 400;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, 400, 400);
    ctx.drawImage(imgEl, 0, 0, 400, 400);
    canvas.toBlob((blob) => resolve(blob), "image/png");
  });

  // ✅ Copy QR as PNG to clipboard
  const handleCopyQR = async () => {
    try {
      const pngBlob = await svgToPngBlob();
      await navigator.clipboard.write([
        new ClipboardItem({ "image/png": pngBlob }),
      ]);
      setCopyLabel("Copied!");
      setTimeout(() => setCopyLabel("Copy QR"), 2000);
    } catch (e) {
      console.error("Copy failed:", e);
      setCopyLabel("Failed");
      setTimeout(() => setCopyLabel("Copy QR"), 2000);
    }
  };

  // ✅ Download QR as PNG
  const handleDownloadQR = async () => {
    try {
      const pngBlob = await svgToPngBlob();
      const link = document.createElement("a");
      link.download = "wechat-qr.png";
      link.href = URL.createObjectURL(pngBlob);
      link.click();
      setTimeout(() => URL.revokeObjectURL(link.href), 1000);
    } catch (e) {
      console.error("Download failed:", e);
    }
  };

  const fabBase = {
    width:"45px",
    height:"45px",
    color: "#fff",
    transition: "all 0.2s ease",
    zIndex: 1300,
  };

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          bottom: 50,
          right: 10,
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
          alignItems: "center",
        }}
      >
        {/* WeChat — opens QR modal */}
        <Tooltip title="Chat on WeChat" placement="left">
          <Fab
            onClick={() => setOpenQR(true)}
            sx={{
              ...fabBase,
              bgcolor: "#07C160 !important",
              boxShadow: "0 4px 16px rgba(7,193,96,0.45)",
              "&:hover": {
                bgcolor: "#06a050",
                transform: "scale(1.08)",
                boxShadow: "0 6px 24px rgba(7,193,96,0.55)",
              },
            }}
          >
            <WeChatIcon />
          </Fab>
        </Tooltip>

         {/* Facebook */}
        <Tooltip title="Visit our Facebook page" placement="left">
          <Fab
            component="a"
            href={facebookUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              ...fabBase,
              bgcolor: "#1877F2",
              boxShadow: "0 4px 16px rgba(24,119,242,0.45)",
              "&:hover": {
                bgcolor: "#145dbf",
                transform: "scale(1.08)",
                boxShadow: "0 6px 24px rgba(24,119,242,0.55)",
              },
            }}
          >
            <FacebookIcon sx={{ fontSize: 20 }} />
          </Fab>
        </Tooltip>

        {/* WhatsApp */}
        <Tooltip title="Chat on WhatsApp" placement="left">
          <Fab
            component="a"
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              ...fabBase,
              bgcolor: "#25D366",
              boxShadow: "0 4px 16px rgba(37,211,102,0.45)",
              "&:hover": {
                bgcolor: "#1ebe5d",
                transform: "scale(1.08)",
                boxShadow: "0 6px 24px rgba(37,211,102,0.55)",
              },
            }}
          >
            <WhatsAppIcon sx={{ fontSize: 20 }} />
          </Fab>
        </Tooltip>
      </Box>

      {/* WeChat QR Modal */}
      <Modal open={openQR} onClose={() => setOpenQR(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: 24,
            p: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
            width: 260,
            outline: "none",
          }}
        >
          <Typography variant="h6" fontWeight={600}>
            WeChat
          </Typography>

          <Typography variant="body2" color="text.secondary" textAlign="center">
            Scan to add on WeChat
          </Typography>

          {/* ✅ Hardcoded QR SVG — no library */}
          <Box
            sx={{
              p: 1,
              border: "1px solid #eee",
              borderRadius: 1,
              bgcolor: "#fff",
            }}
          >
            <img
    ref={qrRef}
    src={wechatQrPng}         // imported PNG
    alt="WeChat QR Code"
    width={180}
    height={180}
    style={{ display: "block" }}
    crossOrigin="anonymous"   // needed for canvas drawImage
  />
          </Box>

          <Typography variant="body2" fontWeight={500}>
            {wechatNumber}
          </Typography>

          {/* Action buttons */}
          <Box sx={{ display: "flex", gap: 1, width: "100%" }}>
            <Box
              component="button"
              onClick={handleCopyQR}
              sx={{
                flex: 1,
                py: 1,
                borderRadius: 2,
                border: "1px solid #ddd",
                bgcolor: "#f5f5f5",
                cursor: "pointer",
                fontSize: 13,
              }}
            >
              {copyLabel}
            </Box>
            <Box
              component="button"
              onClick={handleDownloadQR}
              sx={{
                flex: 1,
                py: 1,
                borderRadius: 2,
                border: "none",
                bgcolor: "#07C160",
                color: "#fff",
                cursor: "pointer",
                fontSize: 13,
              }}
            >
              Save QR
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default FloatingWhatsApp;